
import { Component } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import { getCardRecharge } from "@/api/api-non-name";
import { rechargeCashCard } from "@/api/api-non-name";
import { getCountryCodeList, getAccount } from "@/api/api-basic";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectTableData
  }
})
export default class PiChargeOrderList extends mixins(tableMaxHeight) {
  private tabType = 1;
  formInline: objAny = {
    phone: "",
    email: "",
    countryCode: "",
    amount: "",
    accountPkId: "",
    accountType: ""
  };
  private ruleValidate = {
    phone: [
      {
        required: true,
        validator: regular.tel,
        name: this.$t("cashTopUp.userPhone"),
        trigger: "blur"
      }
    ],
    email: [
      {
        required: true,
        validator: regular.emailRegular,
        trigger: "blur"
      }
    ],
    amount: [
      {
        required: true,
        message: this.$t("cashTopUp.amountTip"),
        trigger: "blur"
      }
    ]
  };

  win: objAny = window;
  tabs = [
    { label: this.$t("cashTopUp.email"), value: 1 },
    { label: this.$t("cashTopUp.phone"), value: 2 },
    {}
  ];
  private showTopUp = false;
  private showConfirm = false;
  show() {
    this.showTopUp = true;
    this.tabType = 1;
    this.$refs.formInline.resetFields();
  }
  cancel() {
    this.showTopUp = false;
  }
  // 获取电话区号
  public codeList: any = [];
  async getCodeList() {
    const res = await getCountryCodeList();
    if (res.status === this.$config.apiStatus) {
      this.codeList = res.data || [];
      if (res.data?.length) {
        this.formInline.countryCode = res.data[0].countryCode;
      }
    }
  }

  typeChange(value: number) {
    if (this.tabType == value) return;
    this.tabType = value;
    this.$refs.formInline.resetFields();
  }

  private submitLoading = false;
  submit() {
    this.$refs.formInline.validate(async valid => {
      if (valid) {
        this.submitLoading = true;
        const res = await getAccount({
          countryCode: this.formInline.countryCode,
          phoneNo: this.formInline.phone,
          email: this.formInline.email
        });
        this.submitLoading = false;
        if (res.status === this.$config.apiStatus) {
          if (res.data?.length) {
            const data = res.data[0];
            this.formInline.accountPkId = data.accountPkId;
            this.formInline.accountType = data.accountType;
            this.showConfirm = true;
          } else {
            this.$Message.error(i18n.t("cashTopUp.accountDoesNotExist"));
          }
        }
      }
    });
  }

  private confirmLoading = false;
  async confirm() {
    const params: objAny = {
      accountPkId: this.formInline.accountPkId,
      rechargeAmount: this.formInline.amount,
      accountType: this.formInline.accountType
    };
    this.confirmLoading = true;
    const ret = await rechargeCashCard(params);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("rechargeSuccess"));
      this.showConfirm = false;
      this.showTopUp = false;
      this.$emit("refesh");
    }
    this.confirmLoading = false;
  }

  mounted(): void {
    this.getCodeList();
  }
}
